import { useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddEditIngredientForm from "../../../components/section/catalog/AddEditIngredientForm";

const EditIngredient = () => {
  const navigate = useNavigate();

  return (
    <div className="container_xxl bg-[#eceff1] px-4">
      <div className="flex items-center space-x-4 headingBorder__b sticky top-0 z-10">
        <div>
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
        </div>
        <div>
          <h1 className="heading">Edit Ingredient</h1>
        </div>
      </div>
      
      <AddEditIngredientForm isEdit={true} />
    </div>
  );
};

export default EditIngredient;
